module.exports = __webpack_public_path__ + "static/media/ozoneMonster.a397d38b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Intro/ozoneMonster.svg
// module id = 903
// module chunks = 0